import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for copyng plan template
export const copyPlanTemplate = createAsyncThunk('planTemplate/copyPlanTemplate', async ({ projectId, planTemplateId, planTemplateName, planTemplatePrice }) => {
  try {
    await fetch(`/api/plans/copy-plan-template`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', 
      },
      body: JSON.stringify({ projectId, planTemplateId, planTemplateName, planTemplatePrice }),
    });
  } catch (error) {
    console.error('Error in createPlan thunk', error);
    throw new Error(error.message || 'An error occurred during the API call');
  }
});

const copyPlanTemplateSlice = createSlice({
  name: 'planTemplate',
  initialState: { status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(copyPlanTemplate.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(copyPlanTemplate.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(copyPlanTemplate.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default copyPlanTemplateSlice.reducer;
